export {}; // （環境によって必要）

interface VimeoOembed {
  thumbnail_url?: string;
  title?: string;
}

const MODAL_ID = 'vimeo-modal';

const extractVimeoIdFromPlayerUrl = (playerUrl: string): string | null => {
  const m = playerUrl.match(/vimeo\.com\/video\/(\d+)/);
  return m?.[1] ?? null;
};

const buildOembedUrl = (vimeoId: string): string => {
  const videoUrl = `https://vimeo.com/${vimeoId}`;
  return `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(videoUrl)}`;
};

const withAutoplay = (playerUrl: string): string => {
  const url = new URL(playerUrl);
  url.searchParams.set('autoplay', '1');
  return url.toString();
};

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById(MODAL_ID);
  if (!modal) return;

  const body = modal.querySelector<HTMLElement>('[data-role="body"]');
  if (!body) return;

  const close = () => {
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
    body.innerHTML = '';
    document.documentElement.classList.remove('overflow-hidden');
  };

  const open = (playerUrl: string) => {
    body.innerHTML = `
      <iframe
        title="vimeo-player"
        src="${withAutoplay(playerUrl)}"
        class="h-full w-full"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
        allowfullscreen
      ></iframe>
    `;
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('overflow-hidden');
  };

  modal.querySelectorAll<HTMLElement>('[data-role="close"]').forEach((el) => {
    el.addEventListener('click', close);
  });

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('hidden')) close();
  });

  document
    .querySelectorAll<HTMLElement>('.vimeo-card')
    .forEach(async (card) => {
      const playerSrc = card.dataset.vimeoSrc;
      if (!playerSrc) return;

      const btn = card.querySelector<HTMLButtonElement>('.vimeo-thumb-btn');
      const img = card.querySelector<HTMLImageElement>('.vimeo-thumb');
      if (!btn || !img) return;

      // サムネ取得
      const id = extractVimeoIdFromPlayerUrl(playerSrc);
      if (id) {
        try {
          const res = await fetch(buildOembedUrl(id));
          if (res.ok) {
            const data = (await res.json()) as VimeoOembed;
            if (data.thumbnail_url) img.src = data.thumbnail_url;
            if (data.title) img.alt = data.title;
          }
        } catch (err) {
          console.warn(err);
        }
      }

      btn.addEventListener('click', () => open(playerSrc));
    });
});
